function getView(viewName, title) {
    return (resolve, reject) => {
        require.ensure([], (require) => {
            let modules = require(`src/views/page/ems/contract/${viewName}`)
            modules.default.options.metaInfo = { title }
            resolve(modules)
        }, reject, 'plan')
    }
}

let routes = [
    {
        name: 'contractList',
        path: '/ems/contractList',
        meta: {
            title: '项目'
        }
    },
    {
        name: 'maintainDetail',
        path: '/ems/maintainDetail',
        meta: {
            title: '项目详情'
        }
    },
    {
        name: 'contractDetail',
        path: '/ems/contractDetail',
        meta: {
            title: '合同详情'
        }
    },
    {
        name: 'engineeringDetail',
        path: '/ems/engineeringDetail',
        meta: {
            title: '项目详情'
        }
    },
    {
        name: 'qualitySafetyDetail',
        path: '/ems/qualitySafetyDetail',
        meta: {
            title: '质安管理详情'
        }
    },
    {
        name: 'baiduMap',
        path: '/ems/baiduMap',
        meta: {
            title: '项目位置编辑'
        }
    }
]

routes.forEach((v) => {
    if (!v.redirect && !v.component) {
        v.component = getView(v.name, v.meta.title)
    }
})

export default routes



// WEBPACK FOOTER //
// ./src/router/modules/ems/contract.js